// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ocbSpan":"OdinCheckbox__ocbSpan---q3m4","ocb":"OdinCheckbox__ocb--jwsbl","ocbLarge":"OdinCheckbox__ocbLarge--ppkpM"};